import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'GiftCertificatesBanner',
  setup(__props) {

const href = 'https://gift.travelata.ru/?utm_source=travelata&utm_medium=banner&utm_campaign=gift_certificates&utm_content=main';

function handleClick() {
  window.location.href = href;
}

return { __sfc: true,href, handleClick }
}

})